/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ buttons: NonNullable<unknown> }} Listingbuttonsautoexplanation3Inputs */

const en_listingbuttonsautoexplanation3 = /** @type {(inputs: Listingbuttonsautoexplanation3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pulsify shows the first four buttons your place has: ${i?.buttons}.`)
};

const de_listingbuttonsautoexplanation3 = /** @type {(inputs: Listingbuttonsautoexplanation3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pulsify zeigt die ersten vier Knöpfe, die dein Ort hat: ${i?.buttons}.`)
};

/**
* | output |
* | --- |
* | "Pulsify shows the first four buttons your place has: {buttons}." |
*
* @param {Listingbuttonsautoexplanation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsautoexplanation3 = /** @type {((inputs: Listingbuttonsautoexplanation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsautoexplanation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsautoexplanation3(inputs)
	return de_listingbuttonsautoexplanation3(inputs)
});
export { listingbuttonsautoexplanation3 as "listingButtonsAutoExplanation" }